import { useCallback, useEffect, useRef, useState } from 'react';

/**
 *
 * @param channelName The name of the broadcast channel
 * @param onMessageReceived callback
 */
export const useBroadcastChannel = (
  channelName: string,
  onMessageReceived: (event: any, broadcastChannel: BroadcastChannel) => void,
) => {
  const broadcastChannelRef = useRef<null | BroadcastChannel>(null);
  const broadcastChannel = broadcastChannelRef.current;
  const [isOpen, setIsOpen] = useState(false);

  const callbackRef = useRef<
    ((event: any, broadcastChannel: BroadcastChannel) => void) | null | undefined
  >(undefined);
  callbackRef.current = onMessageReceived;

  const emitMessage = useCallback(
    (message: any) => {
      broadcastChannel?.postMessage(message);
    },
    [broadcastChannel],
  );

  const closeBroadcastChannel = () => {
    broadcastChannel?.close();
    setIsOpen(false);
  };

  useEffect(() => {
    try {
      broadcastChannelRef.current = new BroadcastChannel(channelName);
      broadcastChannelRef.current.onmessage = (event) => {
        const broadcastChannel = broadcastChannelRef.current as BroadcastChannel;
        callbackRef.current?.(event.data, broadcastChannel);
      };
      setIsOpen(true);
      return () => {
        broadcastChannelRef.current?.close();
        setIsOpen(false);
      };
    } catch (e) {
      console.error('Broadcast channel not supported');
    }
  }, [channelName]);

  return { broadcastChannel, isOpen, closeBroadcastChannel, emitMessage };
};
